// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__3X51T","navbarHidden":"Menu_navbarHidden__3CLy_"};